import React from 'react';
import { useTranslation } from 'react-i18next';

import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { Button } from '@mui/material';

import { useUsersTableContext } from '../../store/usersTableProvider';

const UsersTableClearButton = () => {
    const { t } = useTranslation();
    const { resetUsersTableFilters } = useUsersTableContext();

    return (
        <Button variant="outlined" color="primary" startIcon={<ClearRoundedIcon />} onClick={resetUsersTableFilters}>
            {t('common.action-buttons.clear')}
        </Button>
    );
};

export default UsersTableClearButton;
